import { gql } from "@apollo/client";

export const GET_ACCESS_TOKEN = gql`
    mutation token($phoneNumber: String!, $password: String!, $oauthLoginChallenge: String) {
        token(phoneNumber: $phoneNumber, password: $password, oauthLoginChallenge: $oauthLoginChallenge) {
            token
            refreshToken
            oauthRedirectTo
        }
    }
`;

export const REFRESH_TOKEN = gql`
    mutation tokenRefresh($refreshToken: String!) {
        tokenRefresh(refreshToken: $refreshToken) {
            token
            refreshToken
        }
    }
`;

export const REVOKE_TOKEN = gql`
    mutation tokenRevoke($refreshToken: String!) {
        tokenRevoke(refreshToken: $refreshToken) {
            revoked
        }
    }
`;

export const OTP_STEP_ONE = gql`
    mutation otpStepOne($phoneNumber: String!, $otpChannel: OTPChannelType) {
        otpStepOne(phoneNumber: $phoneNumber, otpChannel: $otpChannel) {
            ok
        }
    }
`;

export const OTP_STEP_TWO = gql`
    mutation otpStepTwo($phoneNumber: String!, $code: String!, $oauthLoginChallenge: String) {
        otpStepTwo(phoneNumber: $phoneNumber, code: $code, oauthLoginChallenge: $oauthLoginChallenge) {
            token
            refreshToken
            oauthRedirectTo
        }
    }
`;

export const ACCEPT_OAUTH_LOGIN = gql`
    mutation acceptOauthLogin($loginChallenge: String!) {
        acceptOauthLogin(loginChallenge: $loginChallenge) {
            redirectTo
        }
    }
`;
